import { render, staticRenderFns } from "./SaaSChildPageContainer.vue?vue&type=template&id=38ea1ef6"
import script from "./SaaSChildPageContainer.vue?vue&type=script&lang=js"
export * from "./SaaSChildPageContainer.vue?vue&type=script&lang=js"
import style0 from "./SaaSChildPageContainer.vue?vue&type=style&index=0&id=38ea1ef6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports